angular.module('country')
    .component('countryList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/country/list.html',
        controller: function ($state, $scope, $stateParams, Country, CountryConst, CountryService) {
            this.reset = () => this.filters = {}
            this.CountryService = CountryService
            $scope.$on(CountryConst.eventUpdate, () => $state.reload())
        }
    })
